<template>
  <v-form-create
    v-if="access.create_employee"
    large
    name="employee"
    top_title="create_employee"
  >
    <v-form ref="form" v-model="valid">
      <v-card-text>
        <v-text-field
          :label="$t('name')"
          v-model="employee.name"
          color="success"
          ref="name"
          :rules="[fieldRules.required]"
        />
        <v-text-field
          :label="$t('email')"
          v-model="employee.email"
          color="success"
          prepend-icon="mdi-email"
          ref="email"
          :rules="[fieldRules.inessentialEmail]"
        />
        <v-text-field
          prefix="+"
          v-mask="mask"
          :label="$t('phone_number')"
          v-model="employee.phone_number"
          color="success"
          prepend-icon="mdi-phone"
          ref="phone_number"
          :rules="[fieldRules.required, fieldRules.employeePhone]"
        />

        <v-text-field
          :label="$t('tin')"
          v-model="employee.tin"
          color="success"
          prepend-icon="mdi-tin"
          ref="tin"
          :rules="[fieldRules.numberString(14)]"
        />

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ $t("status") }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              v-model="employee.is_active"
            />
          </v-list-item-action>
        </v-list-item>

        <v-combobox
          v-if="
            invan_user &&
            invan_user._id != employee._id &&
            (employee._id != undefined || target == 'create') &&
            (employee.role != 'boss' || target == 'create')
          "
          v-model="employee.role"
          v-bind:items="roles"
          item-value="value"
          item-text="name"
          prepend-icon="mdi-account-multiple"
          :label="$t('role')"
          color="success"
          ref="role"
          :rules="[fieldRules.required]"
        />
        <v-text-field
          v-else
          v-bind:value="employee.role"
          readonly
          prepend-icon="mdi-account-multiple"
          :label="$t('role')"
          color="success"
        >
        </v-text-field>
        <!-- <v-combobox
          v-model="employee.workgroup"
          v-bind:items="workgroups"
          item-value="_id"
          item-text="name"
          prepend-icon="mdi-account-group-outline"
          :label="$t('workgroup')"
          color="success"
        /> -->
        <v-layout row px-2>
          <v-flex md6 px-2>
            <v-text-field
              v-model="employee.password"
              :label="$t('password')"
              v-mask="pass_mask"
              counter="6"
              prepend-icon="mdi-security"
              ref="password"
              :rules="[fieldRules.required, fieldRules.employeePassword]"
            />
          </v-flex>
          <v-flex md6 px-2>
            <v-text-field
              v-model="employee.super_password"
              :label="$t('super_password')"
              prepend-icon="mdi-security"
              ref="password"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-form>
    <v-list class="px-2">
      <v-list-item v-for="(service, index) in employee.services" :key="index">
        <v-list-item-content>
          <v-list-item-title>{{ service.service_name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-switch v-model="service.available" />
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <!-- actions -->
    <template #action>
      <v-btn text v-on:click="$to('/employees/list')">{{ $t("cancel") }}</v-btn>
      <v-btn
        text
        color="success"
        :loading="loading_employee"
        v-on:click="save"
        :disabled="!valid"
        >{{ $t(target) }}</v-btn
      >
    </template>
    <!-- Error dialogs -->
    <v-dialog v-model="save_error" width="600">
      <v-card>
        <v-card-title>Save Error</v-card-title>
        <v-card-text>{{ error_message }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="save_error = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form-create>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import Workgroups from "../../mixins/employees/workgroup";
export default {
  name: "ItemsCreate",
  mixins: [Services, Workgroups],
  data: () => ({
    mask: "### (##) ### ## ##",
    pass_mask: "######",
    valid: false,
    is_password: true,
    employee_edit_index: -1,
    page: 1,
    num_pages: 0,
    roles: [],
    employee: {
      services: [],
      is_active: false,
    },
    headers: [
      { text: "Name", value: "name" },
      { text: "Email", value: "email" },
      { text: "Phone", value: "phone_number" },
      { text: "Role", value: "role", align: "right" },
    ],
    data: [],
    employee_loading: false,
    save_error: false,
    error_message: "",
    loading_employee: false,
  }),
  watch: {
    services() {
      this.refresh();
    },
  },
  computed: {
    target() {
      return this.$route.params["target"];
    },
    form() {
      return {
        name: this.employee.name,
        // email: this.employee.email,
        phone_number: this.employee.phone_number,
        role: this.employee.role,
        password: this.employee.password,
      };
    },
    saveDisabled() {
      let formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async save() {
      this.loading_employee = true;
      const employee = this.$copy(this.employee);
      employee.role = employee.role["name"];
      employee.phone_number = this.$communicator.clear_phone_number(
        this.employee.phone_number
      );
      employee.phone_number = "+" + employee.phone_number.slice(4);

      if (employee.workgroup) {
        employee.workgroup_id = employee.workgroup["_id"];
        employee.workgroup_name = employee.workgroup["name"];
        delete employee.workgroup;
      }
      if (this.target == "create") {
        try {
          const res = await this.$communicator("create_employee", {
            params: employee,
          });
          if (res && res.data) {
            if (res.data.statusCode == 200) {
              this.$toast.success("Success", { timeout: 2000 });
              this.$router.push("/employees/list");
            }
            this.save_error = true;
            if (res.data.statusCode == 411) {
              this.error_message = "Phone number allready exist";
              this.$toast.error(`${this.error_message}`, { timeout: 2000 });
            } else if (res.data.statusCode == 412) {
              this.error_message = "Employee with this password allready exist";
            } else if (res.data.statusCode == 404) {
              this.error_message = "Role is not exist";
              this.$toast.error(`${this.error_message}`, { timeout: 2000 });
            } else {
              this.error_message = "Could not save";
            }
          } else {
            this.save_error = true;
            this.error_message = "Netword error";
            this.$toast.error(`${this.error_message}`, { timeout: 2000 });
          }
        } catch (err) {
          this.save_error = true;
          this.error_message = "Netword error";
        }
      } else {
        const res = await this.$communicator("update_employee", {
          arguments: [this.employee._id],
          params: employee,
        });
        if (res && res.data) {
          if (res.data.statusCode == 200) {
            this.$toast.success("Success", { timeout: 2000 });
            this.$router.push("/employees/list");
          }
          this.save_error = true;
          if (res.data.statusCode == 411) {
            this.error_message = "Phone number allready exist";
            this.$toast.error(`${this.error_message}`, { timeout: 2000 });
          } else if (res.data.statusCode == 412) {
            this.error_message = "Employee with this password allready exist";
            this.$toast.error(`${this.error_message}`, { timeout: 2000 });
          } else if (res.data.statusCode == 404) {
            this.error_message = "Role is not exist";
            this.$toast.error(`${this.error_message}`, { timeout: 2000 });
          } else {
            this.error_message = "Could not save";
          }
        } else {
          this.save_error = true;
          this.error_message = "Netword error";
        }
      }
      this.loading_employee = false;
    },
    async remove(items) {
      const indeces = [];
      for (const index in items) {
        indeces.push(items[index]._id);
      }
      await this.$communicator("delete_employees", {
        params: {
          indexes: indeces,
        },
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.update();
    },
    edit(item) {
      if (item === null) {
        this.employee = {
          services: [],
        };
        for (const index in this.services) {
          this.employee.services.push({
            service: this.services[index]._id,
            available: true,
            service_name: this.services[index].name,
          });
        }
        this.employee_edit_index = -1;
      } else {
        this.employee = item;
        this.employee_edit_index = this.employee["_id"];
        this.employee.phone_number = this.$communicator.make_phone_number(
          this.employee.phone_number
        );
        delete this.employee["_id"];
      }
    },
    async refresh() {
      if (this.target == "update") {
        const id = this.$route.query["id"];
        const employee = this.$communicator.then(
          this,
          await this.$communicator("get_employee_by_id", {
            arguments: [id],
          })
        );
        if (employee) {
          if (employee.workgroup_id) {
            employee.workgroup = {
              _id: employee.workgroup_id,
              name: employee.workgroup_name,
            };
          }
          delete employee.admin_token;
          delete employee.employee_token;
          delete employee.boss_token;
          delete employee.workgroup_token;
          delete employee.token;
          this.employee = employee;
        }
      } else {
        for (const index in this.services) {
          this.employee.services.push({
            service: this.services[index]._id,
            available: true,
            service_name: this.services[index].name,
          });
        }
      }
      const roles = this.$communicator.then(
        this,
        await this.$communicator("roles")
      );
      if (roles) this.roles = roles;
    },
    async update() {
      this.employee_loading = true;
      const employees = this.$communicator.then(
        this,
        await this.$communicator("employees", {
          arguments: [10, this.page],
          params: {
            service: this.store._id,
          },
        })
      );
      if (employees) {
        this.num_pages = employees.page;
        this.data = employees.data;
      }
      const roles = this.$communicator.then(
        this,
        await this.$communicator("roles")
      );
      if (roles) this.roles = roles;
      this.employee_loading = false;
    },
  },
  mounted() {
    this.refresh();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
